import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateAgencyModel, AgenciesService, UpdateAgencyCredits } from 'src/app/Api_Module';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-update-agency-credits-modal',
  templateUrl: './update-agency-credits-modal.component.html'
})
export class UpdateAgencyCreditsModalComponent implements OnInit {
  @Input() buttonText?: string;
  @Input() buttonClass?: string;
  @Input() buttonIcon?: string;
  @Input() agency: UpdateAgencyModel;
  loading: boolean;

  constructor(private modalService: NgbModal, private agenciesService: AgenciesService, private toastr: ToastrService) { }

  ngOnInit() {
  }
  openLg(content) {
    this.modalService.open(content, { size: 'lg' });
  }
  update() {
   
    this.agenciesService.updateCredits({ Id: this.agency.id , Credits: this.agency.credits }).subscribe((resp) => {
      this.loading = false;
      this.toastr.success('Credits loaded successfully');
      this.modalService.dismissAll('success');
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
         console.log('error:' + JSON.stringify(error));
      });
  }
}
